export default __webpack_public_path__ + "static/media/integration_banner.6a2f05d6.png";